import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Link from "@material-ui/core/Link";
import LinkIcon from "@material-ui/icons/Link";
import { Typography } from "@material-ui/core";
import { positioningElems } from "../../../config/theme";

const renderLinkText = (text) => {
    if (text?.length > 0 && text.substr(0, 4) !== "http") {
        return "https://" + text;
    }
};

export const linkRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
) =>
    mutable || typeof fieldUpdateHandler === "function" ? (
        <TextField
            value={value || ""}
            error={!!isError}
            helperText={isError}
            InputProps={
                !value || value.length === 0
                    ? {}
                    : {
                          endAdornment: (
                              <InputAdornment position="end">
                                  <Link
                                      href={renderLinkText(value)}
                                      target="_blank"
                                      rel="noopener"
                                  >
                                      <LinkIcon />
                                  </Link>
                              </InputAdornment>
                          ),
                      }
            }
            onChange={(e) => fieldUpdateHandler(name, e.target.value)}
        />
    ) : value ? (
        <Typography
            children={[
                <span key={"link_key"} style={positioningElems.inlineWithIcon}>
                    {value}
                </span>,
                <Link
                    key={"link_key_icon"}
                    href={renderLinkText(value)}
                    target="_blank"
                    rel="noopener"
                >
                    <LinkIcon style={positioningElems.distanceToIcon} />
                </Link>,
            ]}
        />
    ) : (
        []
    );
